import { Flex } from '@workday/canvas-kit-react/layout';
import { system } from '@workday/canvas-tokens-web';
import * as React from 'react';
import Empty, { EmptyProps } from './Empty';

/**
 * Convenience component for nicely spacing buttons as is commonly needed in an empty state.
 */
const EmptyWithButtons: React.FC<React.PropsWithChildren<EmptyProps>> = (props) => (
  <Empty {...props}>
    <Flex gap={system.space.x4}>{props.children}</Flex>
  </Empty>
);

export default EmptyWithButtons;
